// 菜单，侧边栏
import dashboard from './modules/dashboard';

export default [
  dashboard,
  {
    path: '/i18n',
    title: '$t:menu.i18n',
    header: 'home',
    custom: 'i-icon-demo i-icon-demo-i18n'
  }
];
